import styled from '@emotion/styled';
import { Typography } from '@mui/material';

const AllInsurancesContainer = styled('div')({
  display: 'flex',
  flexDirection: 'column',
  width: '100%',
  padding: '10px',
  gap: '10px',
  alignItems: 'center',
});

const InsuranceContainer = styled('div')({
  display: 'flex',
  width: '100%',
  flexDirection: 'column',
  backgroundColor: 'white',
  borderRadius: '10px',
  border: '1px solid #EAEAEA',
  padding: '10px',
});

const InsuranceCardTitle = styled(Typography)({
  display: 'flex',
  fontFamily: 'Poppins',
  fontWeight: 500,
  fontSize: '14px',
  lineHeight: '21px',
  width: '100%',
});

const InsuranceCardText = styled(Typography)({
  display: 'flex',
  fontFamily: 'Poppins',
  fontWeight: 300,
  fontSize: '16px',
  lineHeight: '24px',
  color: '#757475',
});

const Row = styled('div')({
  display: 'flex',
  flexDirection: 'row',
  width: '100%',
  justifyContent: 'space-between',
});

const DeleteIconContainer = styled('button')({
  display: 'flex',
  justifyContent: 'flex-end',
  cursor: 'pointer',
  background: 'transparent',
  borderWidth: '0px',
});

const AddInsuranceButton = styled('button')({
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  padding: '10px',
  backgroundColor: 'transparent',
  width: 'fit-content',
  borderRadius: '20px',
  border: 'none',
  color: '#0A7ABE',
  fontFamily: 'Poppins',
  fontWeight: 500,
  fontSize: '16px',
  lineHeight: '24px',
  cursor: 'pointer',
});

const SkeletonContainer = styled('div')({
  display: 'flex',
  flexDirection: 'column',
  gap: 12,
  width: '100%',
  padding: '10px',
  border: '1px solid #EAEAEA',
  borderRadius: '10px',
});

export {
  AllInsurancesContainer,
  InsuranceCardTitle,
  InsuranceCardText,
  InsuranceContainer,
  Row,
  DeleteIconContainer,
  AddInsuranceButton,
  SkeletonContainer,
};
